var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50008 8.6665L2.16675 5.33317L3.10008 4.3665L4.83342 6.09984V0.666504H6.16675V6.09984L7.90008 4.3665L8.83342 5.33317L5.50008 8.6665ZM1.50008 11.3332C1.13341 11.3332 0.819526 11.2026 0.558415 10.9415C0.297304 10.6804 0.166748 10.3665 0.166748 9.99984V7.99984H1.50008V9.99984H9.50008V7.99984H10.8334V9.99984C10.8334 10.3665 10.7029 10.6804 10.4417 10.9415C10.1806 11.2026 9.86675 11.3332 9.50008 11.3332H1.50008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFileIcon);
export default __webpack_public_path__ + "static/media/select-file-icon.8872a3217ab469e5d67f2bbba6430f88.svg";
export { ForwardRef as ReactComponent };